/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Contentful.RecursionPage.Headline';
export const WhatHappenedHTML = 'Website.Contentful.RecursionPage.WhatHappenedHTML';
export const WhyIsThisAProblemHTML = 'Website.Contentful.RecursionPage.WhyIsThisAProblemHTML';
export const HowToFixItHTML = 'Website.Contentful.RecursionPage.HowToFixItHTML';
export const ReloadPageButton = 'Website.Contentful.RecursionPage.ReloadPageButton';
